<template>
  <div class="widget-mask" @click.stop="closeNotificationWidget">
    <div class="widget" @click.stop>
      <h3 class="title">Последние уведомления</h3>
      <div class="widget__close"
           v-if="mediaBreakpoint !== 'desktop'"
           @click.stop="closeNotificationWidget"
      >
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
          <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
      <div class="notifications-wrap" v-if="notifications.length !== 0">
        <!--<div class="date">
          <h4 class="date__h">Сегодня</h4>
        </div>-->
        <div class="list">
          <transition-group name="notification-list" tag="div">
            <div class="list__item" v-for="(item, i) in notifications" :key="item.id + i.toString()">
              <AppNotification :notification="item"
                               @close-widget="closeNotificationWidget"
                               :removable="isRemoveble(item.itemable_type)"
                               @remove-notification="removeNotification"
                               @show-event-modal="showEventDetailModal"
              />
            </div>
          </transition-group>
        </div>
      </div>
      <transition name="fade">
        <div class="no-content" v-if="notifications.length === 0">
          <AppNoRecordsPlaceholder text="Уведомлений нет" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import AppNotification from '../../aside/AppNotification'
import AppNoRecordsPlaceholder from '../text/AppNoRecordsPlaceholder'
import usersApi from '@/api/usersApi'
import moment from 'moment-timezone'

export default {
  name: 'notification-widget',
  components: { AppNoRecordsPlaceholder, AppNotification },
  computed: {
    notifications () {
      return this.$store.getters.getWidgetNotifications
    },
    mediaBreakpoint () {
      return this.$store.getters.getMediaBreakpoint
    },
    currentUser () {
      return this.$store.getters.currentUser
    }
  },
  methods: {
    closeNotificationWidget () {
      this.$store.dispatch('closeNotificationWidget')
    },
    removeNotification (notificationId) {
      this.$store.dispatch('removeNotificationWidgetNotification', notificationId)
    },
    showEventDetailModal (item) {
      this.$store.commit('[notification] SHOW_DETAIL_EVENT_MODAL', item)
    },
    closeEventDetailModal () {
      this.$store.commit('[notification] CLOSE_DETAIL_EVENT_MODAL')
    },
    isRemoveble (type) {
      switch (type) {
        case 'App\\Models\\Event\\Activity':
          return false
        case 'App\\Models\\Event\\EventMessage':
          return false
        default:
          return true
      }
    }
  },
  mounted () {
    usersApi.getCurrentUser().then(response => {
      const updateData = {
        ...response.data.data,
        roles: response.data.data.roles?.map(role => role.id) || [],
        read_event_at: moment.tz('Asia/Yekaterinburg').format('YYYY-MM-DD HH:mm')
      }

      usersApi.putUser({ id: this.currentUser.id, updateData })
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/vars';
@import '../../../assets/css/system/mixins';

.widget {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  width: 710px;
  background: $color_main;
  overflow: hidden;

  &__close {
    position: absolute;
    top: 0;
    left: auto;
    right: 0;
    padding: 18px;
    color: $font_color_third;
  }
}

.title {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  height: 62px;
  padding-right: 24px;
  padding-left: 24px;
  background: $color_sixth;
  border-bottom: 1px solid $border_color;
  font-weight: bold;
  color: $font_color_third;
  font-size: 16px;
  margin-bottom: 20px;
}

.notifications-wrap {
  flex: 1;
  overflow: auto;

  @media screen and (max-width: $tablet_start) {
    margin-right: 0;
  }

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: $color_third;
  }

  &::-webkit-scrollbar-thumb {
    background-color: $color_second-light;
  }
}

.no-content {
  padding-top: 80px;
}

.date {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  color: $color_second;
  margin-bottom: 34px;

  &__h {
    position: relative;
    z-index: 2;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    width: 108px;
    height: 20px;
    font-size: 14px;
    background: $color_main;
  }

  &:before {
    content: '';
    position: absolute;
    top: auto;
    bottom: auto;
    z-index: 1;
    width: 60%;
    height: 1px;
    background: $border_color;
  }
}

.list {
  position: relative;
  margin-bottom: 34px;
  padding-right: 22px;
  padding-left: 22px;

  @media screen and (max-width: $tablet_start) {
    padding-left: 10px;
    padding-right: 10px;
  }

  &__item {
    margin-bottom: 16px;
    transition: all .5s;
    width: 642px;

    @media screen and (max-width: $tablet_start) {
      width: 100%;
      max-width: 642px;
    }

    .notification {
      width: 100%;
    }
  }
}
</style>
